/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OverviewFacilityDto } from '../../models/overview-facility-dto';

export interface GetOverviewFacilityGroup$Params {
  facilityGroupId: number;
  date?: string;
  isLive?: boolean;
}

export function getOverviewFacilityGroup(http: HttpClient, rootUrl: string, params: GetOverviewFacilityGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<OverviewFacilityDto>>> {
  const rb = new RequestBuilder(rootUrl, getOverviewFacilityGroup.PATH, 'get');
  if (params) {
    rb.path('facilityGroupId', params.facilityGroupId, {});
    rb.query('date', params.date, {});
    rb.query('isLive', params.isLive, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<OverviewFacilityDto>>;
    })
  );
}

getOverviewFacilityGroup.PATH = '/api/facilitygroup/overview/{facilityGroupId}';
